import ENROLLMENT_ACTION_TYPES from '../../constants/actionTypes/enrollmentsActionTypes';
import { IEnrollment, IEnrollmentRequest } from './../../modules/members/enrollments/common/types';

interface EnrollmentAction {
    type: string;
    payload?: any;
}

interface IInitialState {
    enrollmentandenrolleedetails: IEnrollment;
    enrollmentDetails: object;
    responseBasedErrorMessage: string;
    enrollmentRequest: IEnrollmentRequest;
}

export const INITIAL_STATE: IInitialState = {
    enrollmentandenrolleedetails: {} as IEnrollment,
    enrollmentDetails: {},
    responseBasedErrorMessage: '',
    enrollmentRequest: {
        isSuccess: false,
        isError: false,
        errorMessage: '',
        data: {},
    },
};

export default (state = INITIAL_STATE, action: EnrollmentAction) => {
    switch (action?.type) {
        case ENROLLMENT_ACTION_TYPES.SET_ENROLLMENTANDENROLLEE_DETAILS: {
            return {
                ...state,
                enrollmentandenrolleedetails: action.payload as IEnrollment,
                responseBasedErrorMessage: '',
            };
        }
        case ENROLLMENT_ACTION_TYPES.SET_ENROLLMENT_DETAILS: {
            return {
                ...state,
                enrollmentDetails: action.payload,
                responseBasedErrorMessage: '',
            };
        }
        case ENROLLMENT_ACTION_TYPES.SET_PERMISSION_DETAILS: {
            return {
                ...state,
                permissions: action.payload,
                responseBasedErrorMessage: '',
            };
        }

        case ENROLLMENT_ACTION_TYPES.SET_SELECTED_ENROLLMENT: {
            return {
                ...state,
                selectedEnrollment: action.payload,
                responseBasedErrorMessage: '',
            };
        }

        case ENROLLMENT_ACTION_TYPES.SET_REQUEST_RESPONSE: {
            return {
                ...state,
                enrollmentRequest: {
                    ...state.enrollmentRequest,
                    ...action.payload,
                },
            };
        }

        default:
            return state;
    }
};
